export default "__VITE_PUBLIC_ASSET__343255ce__"